import styled from 'styled-components';
import {palette} from '@/styles';

export const Count = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 100%;
  background-color: ${palette.gray800};
  color: ${palette.white};
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: -0.56px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
`;
